import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ebeihilfe-content-section-layout',
  templateUrl: './content-section-layout.component.html',
  styleUrls: ['./content-section-layout.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentSectionLayoutComponent {
  public headline = input<string>();
}
